import { TradeInValue } from '@/types/tradeIn';
import {
  fetchedRemoteData,
  RemoteData,
  remoteDataError,
  unfetchedRemoteData,
} from '../helpers/remoteData';
import { License } from '@/types/license';
import { ReducerInputState } from '@/types/store';
import { Action } from '../actions';

export type LicenseTradeInValueBySerial = {
  [x: License['Serial']]: RemoteData<TradeInValue> | undefined | null;
};

const defaultState = {};

export default function licenseTradeInValueBySerialReducer(
  state: ReducerInputState<LicenseTradeInValueBySerial> = defaultState,
  action: Action,
): LicenseTradeInValueBySerial {
  switch (action.type) {
    case 'FETCH_LICENSE_TRADE_IN_VALUE_START':
      return Object.assign({}, state, {
        [action.licenseSerial]: unfetchedRemoteData<TradeInValue>(),
      });
    case 'FETCH_LICENSE_TRADE_IN_VALUE_SUCCESS':
      return Object.assign({}, state, {
        [action.licenseSerial]: fetchedRemoteData<TradeInValue>(action.tradeInValue),
      });
    case 'FETCH_LICENSE_TRADE_IN_VALUE_FAIL':
      return Object.assign({}, state, {
        [action.licenseSerial]: remoteDataError<TradeInValue>(action.message),
      });
    default:
      return state;
  }
}
